import { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldAlert, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const KEY = "rh.2fa-nag";

/* Owners without two-factor see a slim reminder until they turn it on (dismissable for this browser session). */
export const OwnerTwoFactorBanner = () => {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(KEY) === "1");
  if (!user || user.role !== "owner" || user.totp_enabled || hidden) return null;
  return (
    <div className="mx-auto mt-3 flex max-w-7xl items-center gap-3 px-5 sm:px-10" data-testid="owner-2fa-banner">
      <div className="flex flex-1 items-center gap-3 rounded-lg border border-amber-200 bg-amber-50/90 px-4 py-2 text-sm text-amber-900">
        <ShieldAlert size={16} className="shrink-0" />
        <p className="flex-1">Owners should protect the library with two-factor authentication — it takes a minute with any authenticator app.</p>
        <Link to="/settings?page=account#security" className="shrink-0 rounded-full bg-amber-700 px-3 py-1 text-xs font-medium text-white hover:bg-amber-800" data-testid="owner-2fa-banner-link">Turn it on</Link>
        <button type="button" onClick={() => { sessionStorage.setItem(KEY, "1"); setHidden(true); }} aria-label="Dismiss" className="rounded p-1 text-amber-700 hover:bg-amber-100" data-testid="owner-2fa-banner-dismiss"><X size={14} /></button>
      </div>
    </div>
  );
};
